const SOURCES_MAP = {
  'CelebritiesZenaCelebrity': 'CelebritiesZena',
  'Celebrities': 'Sip'
}

const shuffleBoxes = (boxes, firstSource) => {
  const shuffledBoxes = []
  const usedGuids = []

  while (shuffledBoxes.length < boxes.length) {
    const evenArticle = boxes.find(({ source, guid }) => source === firstSource && !usedGuids.includes(guid))
    shuffledBoxes.push({ ...evenArticle, source: SOURCES_MAP[evenArticle.source] })
    usedGuids.push(evenArticle.guid)

    const oddArticle = boxes.find(({ source, guid }) => source !== firstSource && !usedGuids.includes(guid))
    shuffledBoxes.push({ ...oddArticle, source: SOURCES_MAP[oddArticle.source] })
    usedGuids.push(oddArticle.guid)
  }
  return shuffledBoxes
}

export const getProps = (props) => {
  const {
    widget,
    widget: {
      boxes
    },
    location,
    firstSource
  } = props

  const shuffledBoxes = shuffleBoxes(boxes, firstSource)

  const updatedWidget = {
    ...widget,
    boxes: shuffledBoxes
  }
  Object.assign(updatedWidget.meta.headline, { location })
  Object.assign(updatedWidget.meta.more, { location })

  return {
    ...props,
    widget: updatedWidget
  }
}
